import { useQuery } from '@tanstack/react-query';

import { PROJECT_BASE_URL } from '@/src/components/project/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, queryClient, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from './config';

const url = `${PROJECT_BASE_URL}/email-contacts`;

type EmailRecipient = {
  name: string;
  avatar: string;
  bounce: boolean;
  'email-address': string;
};

type EmailRecipientsResponse = {
  data: EmailRecipient[];
  status: boolean;
};

export const getEmailRecipients = (projectId: string): Promise<EmailRecipientsResponse> => {
  return axios.get(generateRoutePath(url, { projectId }));
};

export const emailRecipientsKeys = {
  all: ['emailRecipients'] as const,
  list: (projectId: string) => [INBOX_API_KEY, ...emailRecipientsKeys.all, projectId] as const,
};

export const handlePrefetch = (projectId) => {
  queryClient.prefetchQuery({
    queryKey: [INBOX_API_KEY, ...emailRecipientsKeys.all, projectId],
    queryFn: () => getEmailRecipients(projectId),
  });
};

type QueryFnType = typeof getEmailRecipients;

type useEmailRecipientsOptions = {
  projectId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useEmailRecipients = ({ projectId, config }: useEmailRecipientsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...emailRecipientsKeys.all, projectId],
    queryFn: () => getEmailRecipients(projectId),
    staleTime: Infinity,
    ...config,
  });
};
